export default "__VITE_ASSET__22d9dbe7__"